import {
    DragEndEvent,
    KeyboardSensor,
    PointerSensor,
    closestCenter,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { UseFieldArrayReturn } from 'react-hook-form';
import { ISaveJobForm, SAVE_JOB_FORM_VALUES } from '../../../../../common';

interface UseDragAndDropProps {
    questionsArray: UseFieldArrayReturn<
        ISaveJobForm,
        SAVE_JOB_FORM_VALUES.QUESTIONS,
        'id'
    >;
}

export const useDragAndDrop = ({ questionsArray }: UseDragAndDropProps) => {
    const { fields, move } = questionsArray;

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;
        const activeId = active.id;
        const overId = over?.id;

        if (overId && activeId !== overId) {
            const oldIndex = fields.findIndex((field) => field.id === activeId);
            const newIndex = fields.findIndex((field) => field.id === overId);

            if (oldIndex === -1 || newIndex === -1) {
                console.warn('Could not find dragged item index');
                return;
            }

            move(oldIndex, newIndex);
        }
    };

    return {
        sensors,
        handleDragEnd,
    };
};

